import BoxLoading from './BoxLoading';

export default BoxLoading;